// extracted by mini-css-extract-plugin
module.exports = {"selectBlock":"Select_selectBlock__mr4_4","selectBlock__select":"Select_selectBlock__select__-ZSjH"};